import _ from 'lodash';

if($('.location-search').length) {

    let searchInput = $('#location-search-input'),
        searchInputForm = $('#location-search-form'),
        searchResultsContainer = $('#search-results-container'),
        requestDriversFormModal = $('#locations-search-request-drivers'),
        noResultsContainer = $('.no-results-container'),
        initialSearchComplete = false,
        ipAddress = '',
        ipAddressState = '',
        resultsCollapsed = false,
        collapseToggle = $('.location-search').find('.collapse-all');

    collapseToggle.on('click', function () {
        $('.multi-collapse').each(function(){
            var id = $(this).attr('id');
            if(!resultsCollapsed) {
                $(this).collapse('hide');
            } else {
                $(this).collapse('show');
            }
        });
        collapseToggle.find('span').text((!resultsCollapsed) ? 'Expand All' : 'Collapse All');
        if(resultsCollapsed) {
            $(this).removeClass('collapsed');
        } else {
            $(this).addClass('collapsed');
        }
        resultsCollapsed = !resultsCollapsed;
    });

    // searchInput.on('keyup', _.debounce(function () {
    //
    //     if(searchInput.val().length > 2) {
    //         locationSearch();
    //     }
    //
    // }, 500));

    searchInputForm.on('submit', function (e) {

        e.preventDefault();

        locationSearch();

    });


    function initialSearchCheck() {
        $.get("https://ipinfo.io/json", function (response) {
            console.log(response);
            if(typeof response.ip !== 'undefined') {
                ipAddress = response.ip;
                ipAddressState = response.region;
            }

            locationSearch();
            // $("#address").html("Location: " + response.city + ", " + response.region);
            // $("#details").html(JSON.stringify(response, null, 4));
        }, "jsonp");
    }

    // initialSearchCheck();

    locationSearch();

    function locationSearch() {

        // console.log(ipAddressState);

        $.post("/wp-admin/admin-ajax.php", {
            'action': 'location_search',
            'query': searchInput.val(),
            'collapsed': resultsCollapsed
            // 'ipAddressState': ipAddressState
        }, function (response) {

            if(!initialSearchComplete) {
                $('.initial-loading-container').addClass('finished-loading');
                noResultsContainer.removeClass('initial-loading');
            }

            if(response.data.results.length) {
                noResultsContainer.addClass('d-none');
            } else {
                noResultsContainer.removeClass('d-none');
            }

            searchResultsContainer.html(response.data.results);

            if(initialSearchComplete) {
                $('html, body').animate({
                    scrollTop: $('.location-search').offset().top
                }, 500);
            }

        });

    }

    let loadingCount = 0;
    let loadingIndicator = setInterval(function () {
        if(initialSearchComplete) {
            clearInterval(loadingIndicator);
            return;
        }

        switch(loadingCount) {
            case 0:
                $('.initial-loading-container h3').text('Loading.');
                break;
            case 1:
                $('.initial-loading-container h3').text('Loading..');
                break;
            case 2:
                $('.initial-loading-container h3').text('Loading..');
                break;
            case 3:
                $('.initial-loading-container h3').text('Loading');
                break;
        }

        if(loadingCount === 3) {
            loadingCount = 0;
        } else {
            loadingCount++;
        }
    }, 500);

    $(document).on('click', '.location-search-request-drivers-form-trigger', function (e) {

        e.preventDefault();

        let branch = $(this).data('branch');

        $('#request-drivers-form-branch').val(branch);

        requestDriversFormModal.modal('show');

    });

}
